export default {
  auth: () => import("/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/layouts/auth.vue"),
  blank: () => import("/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/layouts/blank.vue"),
  default: () => import("/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/layouts/default.vue"),
  spotlight: () => import("/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/layouts/spotlight.vue")
}